// The overlay's focus-trap grabs focus on open, overriding a field's `autofocus` (the field shows a
// focus style but isn't really focused); useAutoFocusField re-asserts focus on the declared field.
export const resolveAutofocusField = (container: HTMLDivElement): HTMLElement | null =>
    container.querySelector<HTMLElement>('input[autofocus], textarea[autofocus]');
